import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const PoliticaReembolso = () => {
  useEffect(() => {
    document.title = "Política de Reembolso - 30 Receitas Express";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Header hideCheckoutButton />
      <main className="py-12 md:py-16">
        <div className="container max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold mb-6">Política de Reembolso</h1>
          <p className="text-sm text-muted-foreground mb-8">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

          <div className="prose prose-slate dark:prose-invert max-w-none space-y-6">
            <section className="bg-primary/5 p-6 rounded-lg border border-primary/20">
              <h2 className="text-2xl font-semibold mb-3 text-primary">Garantia de 7 Dias</h2>
              <p className="text-muted-foreground leading-relaxed">
                Estamos confiantes de que você vai adorar nosso e-book "30 Receitas Express". Por isso, oferecemos uma <strong>garantia incondicional de 7 dias</strong>. Se por qualquer motivo você não estiver satisfeito com sua compra, basta nos avisar dentro deste prazo e faremos o reembolso integral do valor pago.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Prazo para Solicitação</h2>
              <p className="text-muted-foreground leading-relaxed">
                Você tem até 7 (sete) dias corridos, contados a partir da data de confirmação da compra, para solicitar o reembolso. Este prazo está em conformidade com o Código de Defesa do Consumidor brasileiro (Lei nº 8.078/1990, Art. 49).
              </p>
              <p className="text-muted-foreground leading-relaxed mt-3">
                A data de compra é considerada como a data em que você recebeu a confirmação de pagamento e o acesso ao e-book foi liberado.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Como Solicitar o Reembolso</h2>
              <p className="text-muted-foreground leading-relaxed mb-3">
                Para solicitar seu reembolso, siga estas etapas simples:
              </p>
              <ol className="list-decimal pl-6 space-y-3 text-muted-foreground">
                <li>
                  <strong>Envie um e-mail para:</strong>{" "}
                  <a href="mailto:reembolso@receitasem30minutos.com.br" className="text-primary hover:underline">
                    reembolso@receitasem30minutos.com.br
                  </a>
                </li>
                <li>
                  <strong>Assunto do e-mail:</strong> "Solicitação de Reembolso - [Seu Nome]"
                </li>
                <li>
                  <strong>No corpo do e-mail, inclua:</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Seu nome completo</li>
                    <li>E-mail utilizado na compra</li>
                    <li>Data da compra</li>
                    <li>Motivo da solicitação (opcional, mas ajuda a melhorarmos)</li>
                  </ul>
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. Processamento do Reembolso</h2>
              <p className="text-muted-foreground leading-relaxed">
                Após recebermos sua solicitação de reembolso, seguiremos o seguinte processo:
              </p>
              <ul className="list-disc pl-6 space-y-3 text-muted-foreground mt-3">
                <li>
                  <strong>Confirmação:</strong> Enviaremos um e-mail confirmando o recebimento da sua solicitação em até 24 horas úteis
                </li>
                <li>
                  <strong>Análise:</strong> Verificaremos se a solicitação está dentro do prazo de 7 dias e validaremos as informações fornecidas
                </li>
                <li>
                  <strong>Aprovação:</strong> Se tudo estiver correto, aprovaremos o reembolso imediatamente
                </li>
                <li>
                  <strong>Processamento:</strong> O reembolso será processado em até 5 dias úteis após a aprovação
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. Forma de Reembolso</h2>
              <p className="text-muted-foreground leading-relaxed">
                O reembolso será realizado através do mesmo método de pagamento utilizado na compra:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-3">
                <li><strong>Cartão de Crédito:</strong> O estorno aparecerá na sua fatura em 1-2 ciclos de cobrança (30-60 dias), dependendo da administradora do cartão</li>
                <li><strong>PIX:</strong> O valor será devolvido para a conta de origem em até 5 dias úteis</li>
                <li><strong>Boleto Bancário:</strong> Solicitaremos seus dados bancários para realizar a transferência em até 5 dias úteis</li>
                <li><strong>Outros métodos:</strong> Entre em contato para informações específicas</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. Condições e Requisitos</h2>
              <p className="text-muted-foreground leading-relaxed mb-3">
                Nossa política de reembolso é simples e sem complicações. No entanto, alguns requisitos devem ser atendidos:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>A solicitação deve ser feita dentro do prazo de 7 dias corridos</li>
                <li>As informações fornecidas devem corresponder aos dados da compra</li>
                <li>O e-mail de solicitação deve ser enviado do endereço cadastrado na compra (ou comprovar titularidade)</li>
                <li>Apenas uma solicitação de reembolso por compra</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Após o Reembolso</h2>
              <p className="text-muted-foreground leading-relaxed">
                Após o processamento do reembolso:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-3">
                <li>Seu acesso ao e-book será encerrado</li>
                <li>Os links de download serão desativados</li>
                <li>Você não terá mais direito de usar ou reproduzir o conteúdo</li>
                <li>Solicitamos que delete todas as cópias do arquivo em sua posse</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Exceções</h2>
              <p className="text-muted-foreground leading-relaxed mb-3">
                Não poderemos processar reembolsos nas seguintes situações:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Solicitações feitas após o prazo de 7 dias</li>
                <li>Compras feitas através de terceiros não autorizados</li>
                <li>Casos de violação dos Termos de Uso (compartilhamento não autorizado, pirataria, etc.)</li>
                <li>Produtos adquiridos em promoções especiais com termos específicos que excluam reembolso (quando claramente informado)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Feedback e Melhorias</h2>
              <p className="text-muted-foreground leading-relaxed">
                Embora não seja obrigatório, agradecemos muito se você puder compartilhar o motivo da solicitação de reembolso. Seu feedback é valioso e nos ajuda a melhorar continuamente nosso produto e serviço para atender melhor às expectativas dos nossos clientes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">9. Garantia de Satisfação</h2>
              <p className="text-muted-foreground leading-relaxed">
                Nossa garantia de 7 dias demonstra nossa confiança na qualidade do e-book "30 Receitas Express". Queremos que você se sinta seguro em sua compra e tenha tempo suficiente para explorar o conteúdo e experimentar as receitas.
              </p>
              <p className="text-muted-foreground leading-relaxed mt-3">
                Acreditamos que você ficará satisfeito com:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-3">
                <li>30 receitas práticas e testadas</li>
                <li>Ingredientes simples e acessíveis</li>
                <li>Preparo rápido em até 30 minutos</li>
                <li>Instruções claras e fáceis de seguir</li>
                <li>Variedade para diferentes gostos</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">10. Suporte ao Cliente</h2>
              <p className="text-muted-foreground leading-relaxed">
                Antes de solicitar um reembolso, considere entrar em contato com nosso suporte. Muitas vezes, podemos resolver dúvidas ou problemas técnicos rapidamente:
              </p>
              <ul className="list-none space-y-2 text-muted-foreground mt-3">
                <li><strong>E-mail de suporte:</strong> <a href="mailto:suporte@receitasem30minutos.com.br" className="text-primary hover:underline">suporte@receitasem30minutos.com.br</a></li>
                <li><strong>E-mail para reembolso:</strong> <a href="mailto:reembolso@receitasem30minutos.com.br" className="text-primary hover:underline">reembolso@receitasem30minutos.com.br</a></li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">11. Direitos do Consumidor</h2>
              <p className="text-muted-foreground leading-relaxed">
                Esta política está em conformidade com o Código de Defesa do Consumidor (CDC) brasileiro. Além dos direitos aqui descritos, você mantém todos os direitos previstos em lei, incluindo aqueles relacionados a produtos com vícios ou defeitos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">12. Alterações nesta Política</h2>
              <p className="text-muted-foreground leading-relaxed">
                Reservamo-nos o direito de modificar esta Política de Reembolso a qualquer momento. Mudanças significativas serão comunicadas através do e-mail cadastrado. A versão atualizada sempre estará disponível em nosso site com a data da última revisão.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">13. Contato</h2>
              <p className="text-muted-foreground leading-relaxed">
                Para solicitar reembolso ou esclarecer dúvidas sobre esta política:
              </p>
              <ul className="list-none space-y-2 text-muted-foreground mt-3">
                <li><strong>E-mail para reembolso:</strong> <a href="mailto:reembolso@receitasem30minutos.com.br" className="text-primary hover:underline">reembolso@receitasem30minutos.com.br</a></li>
                <li><strong>E-mail para dúvidas:</strong> <a href="mailto:suporte@receitasem30minutos.com.br" className="text-primary hover:underline">suporte@receitasem30minutos.com.br</a></li>
                <li><strong>Empresa:</strong> 30 Receitas Express</li>
              </ul>
            </section>

            <section className="mt-8 p-6 bg-green-500/10 rounded-lg border border-green-500/20">
              <h3 className="text-xl font-semibold mb-3 text-green-700 dark:text-green-400">
                Nossa Promessa
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                Queremos que você fique 100% satisfeito com sua compra. Se por qualquer motivo o e-book não atender suas expectativas nos primeiros 7 dias, devolvemos seu dinheiro sem perguntas e sem complicações. Simples assim!
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PoliticaReembolso;
